import React from 'react';
import { bindActionCreators } from 'redux';
import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import classnames from 'classnames';
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';
import ExcelExportButton from '../common/excelExportButton';
import Paging from '../common/pagingComponent';
import RelationLink from './relations/relationLink';

import './generalAssembliesData.scss';

class MirriPersonalRelationsData extends React.Component {

    state = {
        page: 1,
        totalCount: null,
        loadingTotal: false
    };

    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.sectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    render() {
        const { data, loadingMoreData, isLimited } = this.section;

        var totalCount = 0;
        if (data && data.totalCount)
            totalCount = data.totalCount;
        else if (this.state.totalCount !== null)
            totalCount = this.state.totalCount;

        const max = totalCount > this.pageSize * this.state.page ? this.pageSize * this.state.page : totalCount;

        return isNullOrUndefined(data) || isNullOrUndefined(data.items) ? null : this.renderContent(data, isLimited, loadingMoreData, totalCount, max);
    }

    renderContent = (data, isLimited, loadingMoreData, totalCount, max) => {
        return (
            <div>
                <OldStyleTableWithHistory stripped tableColumns={2}
                    resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead className="relations-header">
                        <tr>
                            <th className="col-2"><Translate id="Report.Relations.NameBusinessName" /></th>
                            <th className="col-2"><Translate id="Report.Relations.Position" /></th>
                            <th className="col-9" style={{ textAlign: 'right' }}><Translate id="Common.Share" /></th>
                            <th className="col-2"><Translate id="Report.Relations.BusinessName" /></th>
                            <th className="col-2"><Translate id="Report.Relations.WarningInfo" /> </th>
                            <th className="col-9" style={{ textAlign: 'right' }}><Translate id="Report.Relations.CompanyId" /></th>
                        </tr>
                    </thead>}
                    actualData={data.items}
                    actualRow={(r) => this.renderRelationRow(r)}
                />
                {isLimited && totalCount > max && this.renderMoreLinks(totalCount, loadingMoreData)}
                {!isLimited && totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                {this.state.loadingTotal && <div style={{ width: "100%", fontSize: "0.1em" }} className="search-progress searching" />}
                <ExcelExportButton link={this.section.link} entityId={this.props.id} report={this.props.reportType} />
            </div>
        )
    }

    renderRelationRow = (r) => {
        return (
            <tr key={r.personEntityId + "_" + r.shareFormated + "_" + r.description + "_" + r.companyEntityId} className={classnames('relations-row', 'colorize')}>
                <td className="col-2"><RelationLink wrap entityName={r.personName} entityId={r.personEntityId} reports={r.personReports} customPrefix={<></>} showOnMobile={true} /></td>
                <td className="col-2">{r.description}</td>
                <td className="col-9" style={{ textAlign: 'right' }}>{r.shareFormatted}</td>
                <td className="col-2"><RelationLink wrap entityName={r.companyName} entityId={r.companyEntityId} reports={r.companyReports} customPrefix={<></>} showOnMobile={true} /></td>
                <td className="col-2">{this.renderWarnings(r.companyWarnings)}</td>
                <td className="col-9" style={{ textAlign: 'right' }}>{r.companyIco}</td>
            </tr>
        );
    }

    renderWarnings = (warnings) => {
        {
            if (warnings !== null && warnings !== undefined && warnings.length > 0)
                return <div style={{ display: "flex", whiteSpace: "pre-wrap" }}>
                    {warnings.map((w, i) =>
                        <div key={w.code} className={`r-padded rel-warn rel-warn-status-${w.statusId}`} title={w.description}>{w.shortening}</div>
                    )}
                </div>
            else return "";
        }
    }

    renderMoreLinks = (totalCount, isLoading) => {
        return (
            <>
                <div style={{ marginLeft: '0.7em', marginBottom: '1em' }}>
                    {this.state.page === 1 && <span className="link-functional" onClick={() => this.getMore()}>
                        <Translate id="Report.Common.More" />
                    </span>}
                    {this.state.page === 2 && <a className="link-functional" target="_blank"
                        href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                    >
                        <Translate id="Report.Common.ShowAll" />
                        <>&nbsp;({totalCount})</>
                    </a>}
                </div>
                {isLoading && <div style={{ width: "100%", paddingBottom: '0', paddingTop: '0' }} className="search-progress searching"></div>}
            </>
        )
    }

    getMore = () => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: this.pageSize, report: this.props.reportType },
            null, this.concatData
        );
        this.setState({ page: 2 });
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType },
            null, this.replaceData
        );
        this.setState({ page: page });
    }

    concatData = (_hint, oldData, newData) => {
        if (!isNullOrUndefined(oldData.items))
            oldData.items = oldData.items.concat(newData.items);
        return oldData;
    }

    replaceData = (_hint, _oldData, data) => data;
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(MirriPersonalRelationsData));